import { render, staticRenderFns } from "./AccordionSectionCheckout.vue?vue&type=template&id=1872e126&scoped=true&"
import script from "./AccordionSectionCheckout.vue?vue&type=script&lang=ts&"
export * from "./AccordionSectionCheckout.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionSectionCheckout.vue?vue&type=style&index=0&id=1872e126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1872e126",
  null
  
)

export default component.exports